import { useReduxState } from 'hooks';
import api from 'api';
import { Alert, ConfirmButton } from 'components/common';

import type { AdminGroupUpdateUsers } from './AdminGroup';

interface Props {
  isAttributeUser?: boolean;
  userId?: number;
  updateUsers: (obj: AdminGroupUpdateUsers) => Promise<void>;
}

const AdminGroupUsersRemove = ({
  isAttributeUser,
  userId,
  updateUsers
}: Props) => {
  const {
    messages,
    pageState: { adminGroupId }
  } = useReduxState();

  const handleConfirm = async () => {
    try {
      await api.delete(
        `/admin/admin-groups/${adminGroupId}/users${userId ? `/${userId}` : ''}`
      );
      await updateUsers({ page: 1, search: '', sortBy: '' });
      return true;
    } catch (err) {}
  };

  const textElements = userId
    ? {
        alert: messages.adminGroupUserRemoveAlert,
        main: messages.commonRemoveUser,
        success: messages.commonRemoveUserSuccess,
        tooltip: messages.adminGroupUserRemoveMessage
      }
    : {
        alert: messages.adminGroupUserRemoveAllAlert,
        main: messages.adminGroupUserRemoveAll,
        success: messages.adminGroupUserRemoveAllSuccess,
        tooltip: messages.adminGroupUserRemoveAllMessage
      };

  return (
    <ConfirmButton
      actionText={messages.commonRemove}
      buttonIcon="trash-alt"
      buttonIsDropdown={true}
      buttonStyle={{ whiteSpace: 'nowrap' }}
      buttonText={textElements.main}
      category="danger"
      confirmTitle={textElements.main}
      confirmText={
        <div>
          {!userId || (userId && isAttributeUser) ? (
            <Alert
              style={{ marginBottom: 15 }}
              text={textElements.alert}
              type="warning-light"
            />
          ) : null}
          {textElements.tooltip}
        </div>
      }
      onConfirm={handleConfirm}
      successMessage={textElements.success}
    />
  );
};

export default AdminGroupUsersRemove;
